import { RUNTIMES, TIBBO_DEVICE_ID } from '@appblocks/platforms/PlatformUtils';
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import { BlockType, CodeBlock, Define } from '@appblocks/codegeneration/types';
import * as micropython from './micropython';
import * as tios from './tios';
import * as simulator from './simulator';

export default class DateTime extends BaseFeature {
    constructor() {
        super();
        this.id = 'datetime';
        this.name = 'DateTime';
        this.requirements = ['rtc'];
    }

    getDependencies() {
        const dependencies = [
            'time',
        ];

        return dependencies;
    }

    getFiles(): string[] {
        if (this.project.runtime === RUNTIMES.TIOS) {
            return [
                'libraries/time/datetime.tbs',
                'libraries/time/datetime.tbh',
            ];
        }
        if (this.project.runtime === RUNTIMES.MICROPYTHON) {
            return [
                'datetime.py',
            ];
        }
        return [];
    }

    getCodeBlocks(): CodeBlock[] {
        switch (this.project.runtime) {
            case 'micropython':
                return micropython.getCodeBlocks(this);
            case 'zephyr':
                return [];
            case 'simulator':
                return simulator.getCodeBlocks(this);
            default:
                return tios.getCodeBlocks(this);
        }
    }
}
